import DeprecatedItemType from './deprecated-item-type';
import { extractStringValueSet } from "./extract-properties";
import SupportedItemType from './supported-item-type';

/**
 * @deprecated - use SupportedItemType instead
 * Lists the types of order items
 */
export default class ItemType extends SupportedItemType {

    static readonly GeneratePDFReport = DeprecatedItemType.GeneratePDFReport;
    static readonly InfectiousDiseaseReport = DeprecatedItemType.InfectiousDiseaseReport;
    static readonly ReportAddendum: string = DeprecatedItemType.ReportAddendum;
    static readonly ReportAmendment: string = DeprecatedItemType.ReportAmendment;

    protected static readonly _valueSet: Set<string> = new Set([...Array.from(SupportedItemType.values), ...Array.from(extractStringValueSet(ItemType))]);


    static get values(): Set<string> {
        // always return a new copy.
        return new Set<string>(ItemType._valueSet);
    }
}
